<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="Table" name="first">
				<el-row>
					<el-col :span="24">
						<el-form :inline="true" :model="filters" label-width="100px">
							<el-form-item>
								<el-button type="primary" v-on:click="addTable">Add</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24">
						<el-card class="box-card" v-for="(item, index) in tableData1" style="cursor: pointer;vertical-align: top;" :key="index">
							<div slot="header" class="clearFix" v-on:click="showDetail(item)">
								<span style="font-weight: bold;font-size: 16px;display: block;">{{ item.sSchemaSelectName }}</span>
								<span style="font-size: 16px;display: block;margin-top:10px;">{{ item.sName }}</span>
							</div>
							<div class="text item" v-on:click="showDetail(item)" style="padding:0 20px;">
								<el-table :data="item.list" style="width: 100%;font-size:12px;" :show-header="false">
									<el-table-column prop="sColumnCode" label=""></el-table-column>
									<el-table-column prop="sColumnName" label=""></el-table-column>
								</el-table>
							</div>
						</el-card>
					</el-col>
				</el-row>
				<el-dialog title="Add Table" :visible.sync="addTableFlag" width="80%">
					<div>
						<el-form :model="form" ref="form" label-width="160px">
							<el-form-item label="Name." prop="sName">
								<el-input v-model="form.sName" placeholder="" style="width:220px;"></el-input>
							</el-form-item>
							<el-form-item label="Schema." prop="sSchemaName">
								<el-select v-model="form.sSchemaName" placeholder="Select">
									<el-option v-for="item in tableData3" :key="item.sSchema" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="DB Table Name." prop="sSelectName">
								<el-input v-model="form.sSelectName" placeholder="" style="width:220px;"></el-input>
								<el-button @click="queryTableColumns">Query</el-button>
							</el-form-item>
							<el-form-item label="Display Column Name." prop="selectColumnList" v-for="(item, index) in form.selectColumnList" :key="index">
								<el-input v-model="item.sColumnName" style="width:220px;" placeholder=""></el-input>
								<label>DB Column Name.</label>
								<el-input v-model="item.sColumnCode" style="width:220px;" placeholder=""></el-input>
								<label>DB Column Type.</label>
								<el-select v-model="item.sColumnType" placeholder="">
									<el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="adddisplayname(form.selectColumnList)">Add+</el-button>
								<el-button type="button" v-if="index>0" v-on:click="deletedisplayname(form.selectColumnList, index)">Delete-</el-button>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="addTableFlag = false">Cancel</el-button>
						<el-button type="primary" @click="saveTable">Confirm</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Edit Table" :visible.sync="viewTableFlag" width="80%">
					<div>
						<el-form label-width="160px">
							<el-form-item label="Name." prop="sName">
								<el-input v-model="view.sName" placeholder="" style="width:220px;"></el-input>
							</el-form-item>
							<el-form-item label="Schema." prop="sSchemaName">
								<el-select v-model="view.sSchemaName" disabled placeholder="Select">
									<el-option v-for="item in tableData3" :key="item.sSchema" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="DB Table Name." prop="sSelectName">
								<el-input v-model="view.sSelectName" disabled placeholder="" style="width:220px;"></el-input>
							</el-form-item>
							<el-form-item label="Display Column Name." prop="list" v-for="(item, index) in view.list" :key="index">
								<el-input v-model="item.sColumnName" style="width:220px;" placeholder=""></el-input>
								<label>DB Column Name.</label>
								<el-input v-model="item.sColumnCode" style="width:220px;" placeholder=""></el-input>
								<label>DB Column Type.</label>
								<el-select v-model="item.sColumnType" placeholder="">
									<el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="adddisplayname(view.list)">Add+</el-button>
								<el-button type="button" v-if="index>0" v-on:click="deletedisplayname(view.list, index)">Delete-</el-button>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="viewTableFlag = false">Cancel</el-button>
						<el-button type="primary" @click="deleteTable">Delete</el-button>
						<el-button type="primary" @click="updateTable">Update</el-button>
					</span>
				</el-dialog>
			</el-tab-pane>
			<el-tab-pane label="Table Relation" name="second">
				<el-row>
					<el-col :span="24">
						<el-form :inline="true" :model="filters" label-width="100px">
							<el-form-item>
								<el-button type="primary" v-on:click="addTableRelation">Add</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24">
						<el-card class="box-card" v-for="(item, index) in tableData2" :key="index" style="cursor: pointer;vertical-align: top;">
							<div slot="header" class="clearFix" v-on:click="showDetail2(item)">
								<div>
									<span style="font-weight: bold;font-size: 16px;display: block;">{{ item.nSelect1Id.sSchemaSelectName }}</span>
									<span style="display: block;font-size: 16px;margin-top: 10px;">{{ item.nSelect1Id.sName }}</span>
								</div>
								<div style="margin-top:10px;">
									<span style="font-weight: bold;font-size: 16px;display: block;">{{ item.nSelect2Id.sSchemaSelectName }}</span>
									<span style="display: block;font-size: 16px;margin-top: 10px;">{{ item.nSelect2Id.sName }}</span>
								</div>
							</div>
							<div class="text item" v-on:click="showDetail2(item)" style="padding:0 0px;">
								<el-table :data="item.list" style="width: 100%;font-size: 12px;" :show-header="false">
									<el-table-column prop="nSelect1Key" label="" width=""></el-table-column>
									<el-table-column prop="nSelect1Key" label="" width="">
										<template slot-scope="scope">
											=
										</template>
									</el-table-column>
									<el-table-column prop="nSelect2Key" label="" width=""></el-table-column>
								</el-table>
							</div>
						</el-card>
					</el-col>
				</el-row>

				<el-dialog title="Add Table Relation" :visible.sync="addTableRelatiionFlag" width="50%">
					<div>
						<el-form :model="form2" ref="form2" label-width="160px">
							<el-form-item label="Schema1" prop="sName">
								<el-select v-model="form2.ku1" placeholder="Select" @change="change(1)">
									<el-option v-for="item in tableData3" :key="item.sSchema" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="DB Table Name1" prop="nSelect1Id">
								<el-select v-model="form2.nSelect1Id" placeholder="" @change="change2(1)">
									<el-option v-for="(item, index) in biao1" :key="index" :label="item.sSelectName" :value="item.nSelectId"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="Schema2" prop="sSchemaName">
								<el-select v-model="form2.ku2" placeholder="Select" disabled @change="change(2)">
									<el-option v-for="item in tableData3" :key="item.sSchema" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="DB Table Name2" prop="nSelect2Id">
								<el-select v-model="form2.nSelect2Id" placeholder="" @change="change2(2)">
									<el-option v-for="(item, index) in biao2" :key="index" :label="item.sSelectName" :value="item.nSelectId"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label="'Relation Colunm1.' + (index + 1)" v-for="(item, index) in form2.selectColumnList" prop="selectColumnList" :key="index">
								<el-select v-model="item.nSelect1Key" placeholder="">
									<el-option v-for="item in ziduan1" :key="item.sColumnCode" :label="item.sColumnCode" :value="item.sColumnCode"></el-option>
								</el-select>
								<label>= Relation Colunm2.{{ index + 1 }}</label>
								<el-select v-model="item.nSelect2Key" placeholder="">
									<el-option v-for="item in ziduan2" :key="item.sColumnCode" :label="item.sColumnCode" :value="item.sColumnCode"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="addRelationCloumn(form2.selectColumnList)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deleteRelationCloumn(form2.selectColumnList, index)">Delete-</el-button>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="addTableRelatiionFlag = false">Cancel</el-button>
						<el-button type="primary" @click="SaveTableRelation">Confirm</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Edit Table Relation" :visible.sync="viewTableRelatiionFlag" width="80%">
					<div>
						<el-form label-width="160px">
							<el-form-item label="Schema1" prop="sName">
								<el-select v-model="view2.nSelect1Id.sSchemaName" disabled placeholder="Select" @change="change(1)">
									<el-option v-for="item in tableData3" :key="item.sSchema" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="DB Table Name1" prop="nSelect1Id">
								<el-select v-model="view2.nSelect1Id.nSelectId" placeholder="" @change="change2(1)">
									<el-option v-for="(item, index) in biao1" :key="index" :label="item.sSelectName" :value="item.nSelectId"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="Schema2" prop="sSchemaName">
								<el-select v-model="view2.nSelect2Id.sSchemaName" disabled placeholder="Select" @change="change(2)">
									<el-option v-for="item in tableData3" :key="item.sSchema" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="DB Table Name2" prop="nSelect2Id">
								<el-select v-model="view2.nSelect2Id.nSelectId" placeholder="" @change="change2(2)">
									<el-option v-for="(item, index) in biao2" :key="index" :label="item.sSelectName" :value="item.nSelectId"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label="'Relation Colunm1.' + (index + 1)" v-for="(item, index) in view2.list" :key="index">
								<el-select v-model="item.nSelect1Key" placeholder="">
									<el-option v-for="item in ziduan1" :key="item.sColumnCode" :label="item.sColumnCode" :value="item.sColumnCode"></el-option>
								</el-select>
								<label>= Relation Colunm2.{{ index + 1 }}</label>
								<el-select v-model="item.nSelect2Key" placeholder="">
									<el-option v-for="item in ziduan2" :key="item.sColumnCode" :label="item.sColumnCode" :value="item.sColumnCode"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="addRelationCloumn(view2.list)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deleteRelationCloumn(view2.list, index)">Delete-</el-button>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="viewTableRelatiionFlag = false">Cancel</el-button>
						<el-button type="primary" @click="DeleteTableRelation">Delete</el-button>
						<el-button type="primary" @click="UpdateTableRelation">Update</el-button>
					</span>
				</el-dialog>
			</el-tab-pane>

			<el-tab-pane label="Stored Procedure" name="last">
				<el-row>
					<el-col :span="24">
						<el-form :inline="true" :model="filters" label-width="100px">
							<el-form-item>
								<el-button type="primary" v-on:click="addSP">Add</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24">
						<el-card class="box-card" v-for="(item, index) in spData" style="cursor: pointer;vertical-align: top;" :key="index">
							<div slot="header" class="clearFix" v-on:click="showDetail3(item)">
								<span style="font-weight: bold;font-size: 16px;display: block;">{{ item.sSchemaSelectName }}</span>
								<span style="font-size: 16px;display: block;margin-top:10px;">{{ item.sName }}</span>
							</div>
							<div class="text item" v-on:click="showDetail3(item)" style="padding:0 20px;">
								<el-table :data="item.list" style="width: 100%;font-size:12px;" :show-header="false">
									<el-table-column prop="sColumnCode" label=""></el-table-column>
									<el-table-column prop="sColumnName" label=""></el-table-column>
								</el-table>
							</div>
						</el-card>
					</el-col>
				</el-row>
				<el-dialog title="Add Stored Procedure" :visible.sync="addSPFlag" width="80%">
					<div>
						<el-form :model="form3" ref="form3" label-width="220px">
							<el-form-item label="Name." prop="sName">
								<el-input v-model="form3.sName" placeholder="" style="width:220px;"></el-input>
							</el-form-item>
							<el-form-item label="Schema." prop="sSchemaName">
								<el-select v-model="form3.sSchemaName" placeholder="Select">
									<el-option v-for="item in tableData3" :key="item.sSchema" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="DB Stored Procedure Name." prop="sSelectName">
								<el-input v-model="form3.sSelectName" placeholder="" style="width:220px;"></el-input>
							</el-form-item>
							<el-form-item label="SP Parameter Name." prop="spConditionList" v-for="(item, index) in form3.spConditionList" :key="'s1' + index">
								<el-input v-model="item.sParameterName" style="width:150px;" placeholder=""></el-input>
								<label>SP Parameter Code.</label>
								<el-input v-model="item.sParameterCode" style="width:150px;" placeholder=""></el-input>
								<label>SP Parameter Type.</label>
								<el-select v-model="item.sParameterType" placeholder="">
									<el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
								<label>Required.</label>
								<el-select v-model="item.sRequired" placeholder="">
									<el-option v-for="a in options3" :key="a.id" :label="a.name" :value="a.id"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="addsppartyname(form3.spConditionList)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deletesppartyname(form3.spConditionList, index)">Delete-</el-button>
							</el-form-item>
							<el-form-item label="Display Column Name." prop="selectColumnList" v-for="(item, index) in form3.selectColumnList" :key="'s2' + index">
								<el-input v-model="item.sColumnName" style="width:150px;" placeholder=""></el-input>
								<label>SP Column Name.</label>
								<el-input v-model="item.sColumnCode" style="width:150px;" placeholder=""></el-input>
								<label>SP Column Type.</label>
								<el-select v-model="item.sColumnType" placeholder="">
									<el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="addspname(form3.selectColumnList)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deletespname(form3.selectColumnList, index)">Delete-</el-button>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="addSPFlag = false">Cancel</el-button>
						<el-button type="primary" @click="saveSP">Confirm</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Edit Stored Procedure" :visible.sync="viewSPFlag" width="80%">
					<div>
						<el-form label-width="160px">
							<el-form-item label="Name." prop="sName">
								<el-input v-model="view3.sName" placeholder="" style="width:220px;"></el-input>
							</el-form-item>
							<el-form-item label="Schema." prop="sSchemaName">
								<el-select v-model="view3.sSchemaName" placeholder="Select">
									<el-option v-for="item in tableData3" :key="item.sSchema" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="DB Table Name." prop="sSelectName">
								<el-input v-model="view3.sSelectName" placeholder="" style="width:220px;"></el-input>
							</el-form-item>
							<el-form-item label="SP Parameter Name." prop="selectColumnList" v-for="(item, index) in view3.spConditionList" :key="'s1' + index">
								<el-input v-model="item.sParameterName" style="width:150px;" placeholder=""></el-input>
								<label>SP Parameter Code.</label>
								<el-input v-model="item.sParameterCode" style="width:150px;" placeholder=""></el-input>
								<label>SP Parameter Type.</label>
								<el-select v-model="item.sParameterType" placeholder="">
									<el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
								<label>Required.</label>
								<el-select v-model="item.sRequired" placeholder="">
									<el-option v-for="a in options3" :key="a.id" :label="a.name" :value="a.id"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="addsppartyname(view3.spConditionList)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deletesppartyname(view3.spConditionList, index)">Delete-</el-button>
							</el-form-item>
							<el-form-item label="Display Column Name." prop="list" v-for="(item, index) in view3.list" :key="'s2' + index">
								<el-input v-model="item.sColumnName" style="width:150px;" placeholder=""></el-input>
								<label>SP Column Name.</label>
								<el-input v-model="item.sColumnCode" style="width:150px;" placeholder=""></el-input>
								<label>SP Column Type.</label>
								<el-select v-model="item.sColumnType" placeholder="">
									<el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="adddisplayname(view3.list)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deletedisplayname(view3.list, index)">Delete-</el-button>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="viewSPFlag = false">Cancel</el-button>
						<el-button type="primary" @click="deleteSpTable">Delete</el-button>
						<el-button type="primary" @click="updateSpTable">Update</el-button>
					</span>
				</el-dialog>
			</el-tab-pane>
			<el-tab-pane label="Database" name="third">
				<el-row>
					<el-col :span="24">
						<el-form :inline="true" :model="filters" label-width="100px">
							<el-form-item>
								<el-button type="primary" v-on:click="addDataBaseFlag = true">Add Database</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24">
						<el-table ref="multipleTable" @row-click="toDataDetail" :data="tableData3" tooltip-effect="dark" style="width: 100%">
							<el-table-column prop="sDatabaseIp" label="Host&Port"></el-table-column>
							<el-table-column prop="sSchema" label="Schema"></el-table-column>
							<el-table-column prop="sUsername" label="User Name"></el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-dialog title="Add Database" :visible.sync="addDataBaseFlag" width="50%">
					<el-form :model="addDataBaseForm" ref="addDataBaseForm" label-width="160px">
						<el-form-item label="Host&Port." prop="sDatabaseIp">
							<el-input v-model="addDataBaseForm.sDatabaseIp" placeholder="Host&Port" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="Schema." prop="sSchema">
							<el-input v-model="addDataBaseForm.sSchema" placeholder="Schema" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="User Name." prop="sUsername">
							<el-input v-model="addDataBaseForm.sUsername" placeholder="User Name" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="Password." prop="sPassword">
							<el-input v-model="addDataBaseForm.sPassword" placeholder="Password" style="width:220px;"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="addDataBaseFlag = false">Cancel</el-button>
						<el-button type="primary" @click="saveAddDataBaseFlag">Confirm</el-button>
					</span>
				</el-dialog>
				<el-dialog title="Edit Database" :visible.sync="editDataBaseFlag" width="50%">
					<el-form :model="editDataBaseForm" ref="editDataBaseForm" label-width="160px">
						<el-form-item label="Host&Port." prop="sDatabaseIp">
							<el-input v-model="editDataBaseForm.sDatabaseIp" disabled="disabled" placeholder="Host&Port" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="Schema." prop="sSchema">
							<el-input v-model="editDataBaseForm.sSchema" disabled="disabled" placeholder="Schema" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="User Name." prop="sUsername">
							<el-input v-model="editDataBaseForm.sUsername" placeholder="User Name" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="Password." prop="sPassword">
							<el-input v-model="editDataBaseForm.sPassword" placeholder="Password" style="width:220px;"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="editDataBaseFlag = false">Cancel</el-button>
						<!--<el-button @click="saveDeleteDataBaseFlag">Delete</el-button>-->
						<el-button type="primary" @click="saveEditDataBaseFlag">Confirm</el-button>
					</span>
				</el-dialog>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
	import {
		getDatabaseInfoList,
		getSelectSecondTableList,
		getTableRelevanceListBySelectList,
		addDatabaseInfo,
		modifyDatabaseInfo,
		selectBysTableName,
		deleteTableRelevance,
		deleteSelect,
		getSelectList,
		updateSelect,
		updateTableRelevance,
		addTableRelevance,
		addSelect,
		getTableRelevanceList,
		getSelectColumnList,
		getSchemaNameList,
		addProcedure,
		updateProcedure,
		selectPSpConditionList
	} from '../../api/api';
	export default {
		data() {
			return {
				addSPFlag: false,
				viewSPFlag: false,
				spData: [],
				editDataBaseFlag: false,
				form3: {
					nSelectType: 2,
					sName: '',
					sSchemaName: '',
					sSelectName: '',
					spConditionList: [{
						sParameterName: '',
						sParameterType: '',
						sParameterCode: '',
						nSequence: 0,
						sRequired: '0'
					}],
					selectColumnList: [{
						sColumnCode: '',
						sColumnName: '',
						sColumnType: ''
					}]
				},
				view3: {
					spConditionList: [],
					list: []
				},
				addDataBaseFlag: false,
				addDataBaseForm: {
					sDatabaseIp: '',
					sUsername: '',
					sPassword: '',
					sSchema: ''
				},
				editDataBaseForm: {
					sDatabaseIp: '',
					sUsername: '',
					sPassword: '',
					sSchema: ''
				},
				tableData3: [],
				addTableFlag: false,
				viewTableFlag: false,
				tableData1: [],
				options: [{
					id: 1,
					name: 'Table'
				}],
				options2: [{
						id: '',
						name: 'Select Type'
					},
					{
						id: 'Number',
						name: 'Number'
					},
					{
						id: 'String',
						name: 'String'
					},
					{
						id: 'Datetime',
						name: 'Datetime'
					}
				],
				options3: [{
						id: '1',
						name: 'Required'
					},
					{
						id: '0',
						name: 'UnRequired'
					}
				],
				biao1: [],
				biao2: [],
				ziduan1: [],
				ziduan2: [],
				form: {
					nSelectType: 1,
					sName: '',
					sSchemaName: '',
					sSelectName: '',
					selectColumnList: [{
						sColumnCode: '',
						sColumnName: '',
						sColumnType: ''
					}],
					spConditionList: [{
						sParameterCode: '',
						sParameterName: '',
						sParameterType: ''
					}]
				},
				form2: {
					nSelect1Id: '',
					nSelect2Id: '',
					ku1: '',
					ku2: '',
					selectColumnList: [{
						nSelect1Key: '',
						nSelect2Key: ''
					}]
				},
				view: {},
				view2: {
					nSelect1Id: {},
					nSelect2Id: {},
					list: []
				},
				addTableRelatiionFlag: false,
				viewTableRelatiionFlag: false,
				activeName: 'first',
				tableData2: [],
				filters: {}
			};
		},
		methods: {
			queryTableColumns() {
				selectBysTableName({
					sTableName: this.form.sSelectName,
					sSchema: this.form.sSchemaName
				}).then(res => {
					var arr = [];
					var _type = {
						numeric: "Number",
						nvarchar: "String",
						varchar: "String",
						datetime: "Datetime",
						datetime2: "Datetime",
						'int': "Number"
					}
					res.data.forEach(one => {
						arr.push({
							nColumnOrder: one.nOrder,
							sColumnCode: one.name,
							sColumnName: one.name,
							sColumnType: _type[one.type]
						})
					});
					this.form.selectColumnList = arr;
				});
			},
			saveSP() {
				if(!this.form3.sName) {
					this.$message.error('Please enter the name');
					return;
				}
				if(!this.form3.sSchemaName) {
					this.$message.error('Please enter the Schema');
					return;
				}
				if(!this.form3.sSelectName) {
					this.$message.error('Please select the DB table name');
					return;
				}
				var flag = false;
				for(var i = 0; i < this.form3.selectColumnList.length; i++) {
					if(!this.form3.selectColumnList[i]['sColumnName']) {
						flag = true;
						this.$message.error('Please enter the display column name');
						return;
					}
					if(!this.form3.selectColumnList[i]['sColumnCode']) {
						flag = true;
						this.$message.error('Please enter the DB column name');
						return;
					}
					if(!this.form3.selectColumnList[i]['sColumnType']) {
						flag = true;
						this.$message.error('Please select the DB column Type');
						return;
					}
				}
				var flag = false;
				for(var i = 0; i < this.form3.spConditionList.length; i++) {
					this.form3.spConditionList[i]['nSequence'] = i;
					if(!this.form3.spConditionList[i]['sParameterName']) {
						flag = true;
						this.$message.error('Please enter the SP Parameter Name');
						return;
					}
					if(!this.form3.spConditionList[i]['sParameterCode']) {
						flag = true;
						this.$message.error('Please enter the SP Parameter Code');
						return;
					}
					if(!this.form3.spConditionList[i]['sParameterType']) {
						flag = true;
						this.$message.error('Please select the SP Parameter Type');
						return;
					}
				}
				if(flag == true) {
					return;
				}
				addProcedure(this.form3).then(res => {
					this.addSPFlag = false;
					this.$refs.form3.resetFields();
					this.$message('Add Success');
					this.getAlltable();
				});
				//console.log(this.form3);
			},
			addSP() {
				this.addSPFlag = true;
				this.form3.spConditionList = [{
					sParameterName: '',
					sParameterType: '',
					sParameterCode: '',
					nSequence: 0,
					sRequired: '0'
				}];
				this.form3.selectColumnList = [{
					sColumnCode: '',
					sColumnName: '',
					sColumnType: ''
				}];
			},
			addTable() {
				this.addTableFlag = true;
				this.form.selectColumnList = [{
					nColumnOrder: '1',
					sParameterCode: '',
					sParameterName: '',
					sParameterType: ''
				}];
			},
			addTableRelation() {
				this.addTableRelatiionFlag = true;
				this.form2.selectColumnList = [{
					nSelect1Key: '',
					nSelect2Key: ''
				}];
			},
			change(type) {
				this.form2.ku2 = this.form2.ku1;
				getSelectList({
					currentPage: 1,
					sSchemaName: type == 1 ? this.form2.ku1 : this.form2.ku2,
					pageSize: 9999
				}).then(res => {
					this.biao1 = res.data;
					this.biao2 = res.data;
					//					if(type == 1) {
					//						this.biao1 = res.data;
					//					} else {
					//						this.biao2 = res.data;
					//					}
				});
			},
			change2(type) {
				getSelectColumnList({
					currentPage: 1,
					nSelectId: type == 1 ? this.form2.nSelect1Id : this.form2.nSelect2Id,
					pageSize: 9999
				}).then(res => {
					if(type == 1) {
						this.ziduan1 = res.data;
					} else {
						this.ziduan2 = res.data;
					}
				});
			},
			showDetail3(item) {
				selectPSpConditionList({
					nSelectId: item.nSelectId
				}).then(res => {
					res.data.sort(function(a, b) {
						return a.nSequence - b.nSequence;
					});
					item.spConditionList = res.data;
					this.view3 = item;
					this.viewSPFlag = true;
				});
			},
			showDetail(item) {
				this.view = item;
				this.viewTableFlag = true;
			},
			showDetail2(item) {
				this.view2 = item;
				getSelectList({
					currentPage: 1,
					sSchemaName: item.nSelect1Id.sSchemaName,
					pageSize: 9999
				}).then(res => {
					this.biao1 = res.data;
					getSelectList({
						currentPage: 1,
						sSchemaName: item.nSelect2Id.sSchemaName,
						pageSize: 9999
					}).then(res => {
						this.biao2 = res.data;
					});
				});
				getSelectColumnList({
					currentPage: 1,
					nSelectId: item.nSelect1Id.nSelectId,
					pageSize: 9999
				}).then(res => {
					this.ziduan1 = res.data;
					getSelectColumnList({
						currentPage: 1,
						nSelectId: item.nSelect2Id.nSelectId,
						pageSize: 9999
					}).then(res => {
						this.ziduan2 = res.data;
					});
				});
				this.viewTableRelatiionFlag = true;
			},
			deleteSpTable() {
				var _this = this;
				this.$confirm('Confirm to Delete Stored Procedure?', 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					})
					.then(() => {
						deleteSelect({
							nSelectId: _this.view3.nSelectId
						}).then(res => {
							_this.viewSPFlag = false;
							_this.$message('Delete Success');
							_this.getAlltable();
						});
					})
					.catch(() => {});
			},
			updateSpTable() {
				var obj = {
					sName: this.view3.sName,
					nSelectType: this.view3.nSelectType,
					nSelectId: this.view3.nSelectId,
					sSchemaName: this.view3.sSchemaName,
					sSelectName: this.view3.sSelectName,
					selectColumnList: [],
					spConditionList: []
				};
				var arr = [];
				for(var i = 0; i < this.view3.list.length; i++) {
					arr.push({
						sColumnCode: this.view3.list[i]['sColumnCode'],
						sColumnName: this.view3.list[i]['sColumnName'],
						sColumnType: this.view3.list[i]['sColumnType']
					});
				}
				for(var i = 0; i < this.view3.spConditionList.length; i++) {
					this.view3.spConditionList[i]['nSequence'] = i;
				}
				obj.selectColumnList = arr;
				obj.spConditionList = this.view3.spConditionList;

				updateProcedure(obj).then(res => {
					this.viewSPFlag = false;
					this.$message('Update Success');
					this.getAlltable();
				});
			},
			deleteTable() {
				var _this = this;
				getSelectSecondTableList({
					nSelect1Id: _this.view.nSelectId,
					sSchemaName: _this.view.sSchemaName
				}).then(res => {
					if(res.data.length == 0) {
						this.$confirm('Confirm to Delete Table?', 'Tips', {
								type: 'warning',
								customClass: 'customConfimClass'
							})
							.then(() => {
								deleteSelect({
									nSelectId: _this.view.nSelectId
								}).then(res => {
									_this.viewTableFlag = false;
									_this.$message('Delete Success');
									_this.getAlltable();
								});
							})
							.catch(() => {});
					} else {
						var arr = [];
						for(var i = 0; i < res.data.length; i++) {
							arr.push(res.data[i]['sSchemaName'] + '.' + res.data[i]['sSelectName']);
						}
						this.$confirm('Confirm to Delete Table? This table has relations to ' + arr.join(','), 'Tips', {
								type: 'warning',
								customClass: 'customConfimClass'
							})
							.then(() => {
								deleteSelect({
									nSelectId: _this.view.nSelectId
								}).then(res => {
									_this.viewTableFlag = false;
									_this.$message('Delete Success');
									_this.getAlltable();
								});
							})
							.catch(() => {});
					}
				});
			},
			updateTable() {
				var obj = {
					sName: this.view.sName,
					nSelectType: this.view.nSelectType,
					nSelectId: this.view.nSelectId,
					sSchemaName: this.view.sSchemaName,
					sSelectName: this.view.sSelectName,
					selectColumnList: []
				};
				var arr = [];
				for(var i = 0; i < this.view.list.length; i++) {
					arr.push({
						sColumnCode: this.view.list[i]['sColumnCode'],
						sColumnName: this.view.list[i]['sColumnName'],
						sColumnType: this.view.list[i]['sColumnType'],
						nColumnOrder: this.view.list[i]['nColumnOrder']
					});
				}
				obj.selectColumnList = arr;

				updateSelect(obj).then(res => {
					this.viewTableFlag = false;
					this.$message('Update Success');
					this.getAlltable();
				});
			},
			saveTable() {
				if(this.form.nSelectType == 1) {
					delete this.form.spConditionList;
				}
				if(!this.form.sName) {
					this.$message.error('Please enter the name');
					return;
				}
				if(!this.form.sSchemaName) {
					this.$message.error('Please enter the Schema');
					return;
				}
				if(!this.form.sSelectName) {
					this.$message.error('Please select the DB table name');
					return;
				}
				var flag = false;
				for(var i = 0; i < this.form.selectColumnList.length; i++) {
					if(!this.form.selectColumnList[i]['sColumnName']) {
						flag = true;
						this.$message.error('Please enter the display column name');
						return;
					}
					if(!this.form.selectColumnList[i]['sColumnCode']) {
						flag = true;
						this.$message.error('Please enter the DB column name');
						return;
					}
					if(!this.form.selectColumnList[i]['sColumnType']) {
						flag = true;
						this.$message.error('Please select the DB column Type');
						return;
					}
				}
				if(flag == true) {
					return;
				}
				addSelect(this.form).then(res => {
					this.addTableFlag = false;
					this.$refs.form.resetFields();
					this.$message('Add Success');
					this.getAlltable();
				});
			},
			DeleteTableRelation() {
				var _this = this;
				this.$confirm('Confirm to Delete Table Relation?', 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					})
					.then(() => {
						deleteTableRelevance({
							nSelect1Id: _this.view2.nSelect1Id.nSelectId,
							nSelect2Id: _this.view2.nSelect2Id.nSelectId
						}).then(res => {
							_this.viewTableRelatiionFlag = false;
							_this.$message('Delete Success');
							_this.getAlltable();
						});
					})
					.catch(() => {});
			},
			UpdateTableRelation() {
				var obj = {
					nSelect1Id: this.view2.nSelect1Id.nSelectId,
					nSelect2Id: this.view2.nSelect2Id.nSelectId,
					selectColumnList: []
				};
				var arr = [];
				for(var i = 0; i < this.view2.list.length; i++) {
					arr.push({
						nSelect1Key: this.view2.list[i]['nSelect1Key'],
						nSelect2Key: this.view2.list[i]['nSelect2Key']
					});
				}
				obj.selectColumnList = arr;
				updateTableRelevance(obj).then(res => {
					this.viewTableRelatiionFlag = false;
					this.$message('Update Success');
					this.getAlltable();
				});
			},
			SaveTableRelation() {
				if(!this.form2.nSelect1Id) {
					this.$message.error('Please enter the DB Table Name1');
					return;
				}
				if(!this.form2.nSelect2Id) {
					this.$message.error('Please enter the DB Table Name2');
					return;
				}
				var flag = false;

				for(var i = 0; i < this.form2.selectColumnList.length; i++) {
					if(!this.form2.selectColumnList[i]['nSelect1Key']) {
						flag = true;
						this.$message.error('Please select the Relation Colunm1');
						return;
					}
					if(!this.form2.selectColumnList[i]['nSelect2Key']) {
						flag = true;
						this.$message.error('Please select the Relation Colunm2');
						return;
					}
				}
				if(flag == true) {
					return;
				}

				addTableRelevance(this.form2).then(res => {
					this.addTableRelatiionFlag = false;
					this.$refs.form2.resetFields();
					this.$message('Add Success');
					this.getAlltable();
				});
			},
			addRelationCloumn(item) {
				item.push({
					nSelect1Key: '',
					nSelect2Key: ''
				});
			},
			deleteRelationCloumn(item, index) {
				item.splice(index, 1);
			},
			adddisplayname(item) {
				try {
					var max = item[item.length - 1]['nColumnOrder'] * 1 + 1
				} catch(e) {
					var max = item.length + 1
				}
				item.push({
					nColumnOrder: max,
					sColumnCode: '',
					sColumnName: '',
					sColumnType: ''
				});
			},
			deletedisplayname(item, index) {
				item.splice(index, 1);
			},
			addspname(item) {
				item.push({
					sColumnCode: '',
					sColumnName: '',
					sColumnType: ''
				});
			},
			deletesppartyname(item, index) {
				item.splice(index, 1);
			},
			addsppartyname(item) {
				item.push({
					sParameterName: '',
					sParameterType: '',
					sParameterCode: '',
					nSequence: item.length,
					sRequired: '0'
				});
			},
			deletespname(item, index) {
				item.splice(index, 1);
			},
			saveAddDataBaseFlag() {
				if(!this.addDataBaseForm.sDatabaseIp) {
					this.$message.error('Please enter database Ip');
					return;
				}
				if(!this.addDataBaseForm.sSchema) {
					this.$message.error('Please enter the schema');
					return;
				}
				if(!this.addDataBaseForm.sUsername) {
					this.$message.error('Please enter the User name');
					return;
				}
				if(!this.addDataBaseForm.sPassword) {
					this.$message.error('Please enter the password');
					return;
				}
				addDatabaseInfo(this.addDataBaseForm).then(res => {
					this.$refs.addDataBaseForm.resetFields();
					this.addDataBaseFlag = false;
					this.getListDatabase();
				});
			},
			toDataDetail(item) {
				this.editDataBaseForm = item;
				this.editDataBaseFlag = true;
			},
			saveEditDataBaseFlag() {
				if(!this.editDataBaseForm.sDatabaseIp) {
					this.$message.error('Please enter database Ip');
					return;
				}
				if(!this.editDataBaseForm.sSchema) {
					this.$message.error('Please enter the schema');
					return;
				}
				if(!this.editDataBaseForm.sUsername) {
					this.$message.error('Please enter the User name');
					return;
				}
				if(!this.editDataBaseForm.sPassword) {
					this.$message.error('Please enter the password');
					return;
				}
				modifyDatabaseInfo(this.editDataBaseForm).then(res => {
					this.$refs.editDataBaseForm.resetFields();
					this.editDataBaseFlag = false;
					this.getListDatabase();
				});

			},
			saveDeleteDataBaseFlag() {
				var _this = this;
				this.$confirm('Confirm to Delete?', 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					})
					.then(() => {
						//						updateUserInfo({
						//							nUserIds: arr,
						//							sState: sState
						//						}).then(res => {
						_this.getListDatabase();
						//						});
					})
					.catch(() => {});
			},
			getListDatabase() {
				getDatabaseInfoList({
					currentPage: 1,
					pageSize: 9999
				}).then(res => {
					this.tableData3 = res.data;
				});
			},
			getAlltable() {
				getSelectColumnList({
					nSelectType: 1,
					currentPage: 1,
					pageSize: 9999
				}).then(res2 => {
					var obj = {};
					var obj2 = {};
					for(var i = 0; i < res2.data.length; i++) {
						if(res2.data[i]['nSelectType'] == 1) {
							if(!obj[res2.data[i]['nSelectId']]) {
								obj[res2.data[i]['nSelectId']] = res2.data[i];
								obj[res2.data[i]['nSelectId']]['list'] = [];
							}
							obj[res2.data[i]['nSelectId']]['list'].push(res2.data[i]);
						} else {
							if(!obj2[res2.data[i]['nSelectId']]) {
								obj2[res2.data[i]['nSelectId']] = res2.data[i];
								obj2[res2.data[i]['nSelectId']]['list'] = [];
								obj2[res2.data[i]['nSelectId']]['spConditionList'] = [];
							}
							obj2[res2.data[i]['nSelectId']]['list'].push(res2.data[i]);
						}
					}
					var arr = [];
					for(var i in obj) {
						arr.push(obj[i]);
					}
					this.tableData1 = arr;

					var arr = [];
					for(var i in obj2) {
						arr.push(obj2[i]);
					}
					this.spData = arr;

					getTableRelevanceList({
						currentPage: 1,
						pageSize: 9999
					}).then(res3 => {
						var obj = {};
						for(var i = 0; i < res3.data.length; i++) {
							if(!obj[res3.data[i]['nSelect1Id'] + '-' + res3.data[i]['nSelect2Id']]) {
								obj[res3.data[i]['nSelect1Id'] + '-' + res3.data[i]['nSelect2Id']] = {
									nSelect1Id: res3.data[i]['nSelect1Id'],
									nSelect2Id: res3.data[i]['nSelect2Id'],
									list: []
								};
							}
							obj[res3.data[i]['nSelect1Id'] + '-' + res3.data[i]['nSelect2Id']]['list'].push(res3.data[i]);
						}
						var arr = [];
						for(var i in obj) {
							arr.push(obj[i]);
						}
						for(var i = 0; i < arr.length; i++) {
							for(var j = 0; j < this.tableData1.length; j++) {
								if(arr[i]['nSelect1Id'] == this.tableData1[j]['nSelectId']) {
									arr[i]['nSelect1Id'] = this.tableData1[j];
								}
								if(arr[i]['nSelect2Id'] == this.tableData1[j]['nSelectId']) {
									arr[i]['nSelect2Id'] = this.tableData1[j];
								}
							}
						}
						this.tableData2 = arr;
					});
				});
			}
		},
		mounted() {
			this.getAlltable();
			this.getListDatabase();
			//this.getKuming();
		}
	};
</script>

<style></style>


// WEBPACK FOOTER //
// data.vue?ae80da2e